import { render, staticRenderFns } from "./OT.vue?vue&type=template&id=176bfe12&"
import script from "./OT.vue?vue&type=script&lang=js&"
export * from "./OT.vue?vue&type=script&lang=js&"
import style0 from "./OT.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports